/**
 * @license
 * Copyright 2019 Xunlei Network.
 *
 * @description
 * Native api.
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNativeApi = exports.checkCanUseNativeApi = void 0;
var device_check_1 = require("../common/device-check");
var tbc_native_api_1 = require("./tbc-native-api");
var account_mobile_sdk_native_api_1 = require("./account-mobile-sdk-native-api");
var old_mobile_native_api_1 = require("./old-mobile-native-api");
var xl_mac_native_api_1 = require("./xl-mac-native-api");
var interface_1 = require("./interface");
Object.defineProperty(exports, "NativeApi", { enumerable: true, get: function () { return interface_1.NativeApi; } });
var canUseNativeApiFlag = undefined;
var nativeApi = undefined;
/**
 * 检查是否可以使用native api。
 * @return {boolean}
 */
function checkCanUseNativeApi() {
    if (canUseNativeApiFlag === undefined) {
        if (device_check_1.isNewTBC()) {
            canUseNativeApiFlag = true;
        }
        else if (device_check_1.checkSupportAccountMobileSDK()) {
            canUseNativeApiFlag = true;
        }
        else if (device_check_1.isOldAndroidMobileClient() || device_check_1.isOldIOSMobileClient()) {
            canUseNativeApiFlag = true;
        }
        else if (device_check_1.isXlMac()) {
            canUseNativeApiFlag = true;
        }
        else {
            canUseNativeApiFlag = false;
        }
    }
    return canUseNativeApiFlag;
}
exports.checkCanUseNativeApi = checkCanUseNativeApi;
/**
 * 创建native api。
 *
 * @param {string} name 唯一标志
 * @return {NativeApi}
 */
function createNativeApi(name) {
    if (nativeApi === undefined) {
        if (device_check_1.isNewTBC()) {
            nativeApi = new tbc_native_api_1.TBCNativeApi();
        }
        else if (device_check_1.checkSupportAccountMobileSDK()) {
            nativeApi = new account_mobile_sdk_native_api_1.MobileAccountSDKNativeApi(name);
        }
        else if (device_check_1.isOldAndroidMobileClient() || device_check_1.isOldIOSMobileClient()) {
            nativeApi = new old_mobile_native_api_1.OldMobileNativeApi(name);
        }
        else if (device_check_1.isXlMac()) {
            nativeApi = new xl_mac_native_api_1.XLMacNativeApi();
        }
        else {
            nativeApi = null;
        }
    }
    return nativeApi;
}
exports.createNativeApi = createNativeApi;
//# sourceMappingURL=index.js.map